// extracted by mini-css-extract-plugin
export default {"modal":"ModalPrint_modal__nbFMu"};